import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getPostsFeedType } from 'redux/selectors';
import { isServicePostState } from '../utils/servicePostUtils';
import { SwitcherRadios, ServiceOptions } from './';
import styles from '../editPost.module.css';

export default function EditPostServiceSelector({ state, setState }) {
	const feedType = useSelector(getPostsFeedType);

	const [activeServiceCategoryIndex, setActiveServiceCategoryIndex] =
		useState(null);

	return (
		<div className={styles.editPostServiceSelectorRoot}>
			<div className={styles.editPostServiceSelectorContent}>
				{!state.id && (
					<SwitcherRadios
						state={state}
						setState={setState}
						setActiveServiceCategoryIndex={setActiveServiceCategoryIndex}
					/>
				)}
				{feedType === 'services' || isServicePostState(state) ? (
					<ServiceOptions
						{...{
							state,
							setState,
							activeServiceCategoryIndex,
							setActiveServiceCategoryIndex,
						}}
					/>
				) : null}
			</div>
		</div>
	);
}
